const FaqsData = [
  {
    question:
      'How can I integrate my business software with QC Logistics solutions?',
    answer:
      'You can integrate using our modern APIs, which seamlessly connect QC Logistics with your ERP, CRM, or eCommerce platform, automating tasks like order processing, shipment tracking, and invoicing.',
  },
  {
    question:
      'Can QC Express Logistics integrate with my existing ERP, CRM, or eCommerce platforms?',
    answer:
      'Yes! Our APIs work with popular platforms like SAP, Oracle, Salesforce, Shopify, and Magento, ensuring a smooth connection between your business software and our logistics solutions.',
  },
  // {
  //   question: 'What are webhooks, and how do they help my business?',
  //   answer:
  //     'Webhooks provide real-time shipment updates, automatically notifying your system when a shipment status changes, reducing manual tracking and improving customer communication.',
  // },
  {
    question: 'How do I test QC Logistics APIs before full integration?',
    answer:
      'We provide a sandbox testing environment where you can experiment with our APIs, simulate transactions, and ensure smooth functionality before going live.',
  },
  {
    question: 'How does integrating QC Logistics benefit my business?',
    answer:
      'By connecting your software with QC Logistics, you can automate shipping, reduce manual work, improve tracking visibility, optimize costs, and enhance customer experience, leading to faster, more efficient operations.',
  },
  {
    question: 'How secure is the integration process?',
    answer:
      'We use API authentication, encryption, and regular security updates to protect your business data and ensure safe transactions.',
  },
  // {
  //   question:
  //     "Do you support multi-carrier shipping?",
  //   answer:
  //     'Yes! Our APIs allow you to compare shipping rates and transit times across multiple carriers, giving you the flexibility to choose the best option for your business.',
  // },
]

export default FaqsData
